const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

// Cloudflare Turnstile. The script loads on first use, so it only runs for experts who open a claim modal.
const TurnstileService = class TurnstileService {
  constructor ($document, $q, Configuration) {
    'ngInject'

    this.$document = $document
    this.$q = $q
    this.Configuration = Configuration
    this.scriptPromise = null
  }

  loadScript () {
    if (!this.scriptPromise) {
      this.scriptPromise = this.$q((resolve, reject) => {
        const script = this.$document[0].createElement('script')
        script.src = SCRIPT_URL
        script.async = true
        script.onload = () => resolve(window.turnstile)
        script.onerror = () => {
          this.scriptPromise = null
          reject(new Error('Turnstile script failed to load'))
        }
        this.$document[0].head.appendChild(script)
      })
    }
    return this.scriptPromise
  }

  // Resolves with the widget id. Rejects if the widget can't be shown at all.
  render (element, options) {
    const siteKey = this.Configuration.turnstile?.siteKey
    if (!siteKey) {
      return this.$q.reject(new Error('Turnstile site key is not configured'))
    }
    return this.loadScript().then(turnstile => turnstile.render(element, { sitekey: siteKey, ...options }))
  }

  reset (widgetId) {
    window.turnstile?.reset(widgetId)
  }

  remove (widgetId) {
    window.turnstile?.remove(widgetId)
  }
}

export default TurnstileService
